import * as Types from '../../../../types/gen/graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type JobBenefitOptionFragment = { __typename?: 'JobBenefit'; id: string; labelJp: string };

export type JobCrewCategoryOptionFragment = {
  __typename?: 'JobCrewCategoryMaster';
  id: string;
  labelJp: string;
};

export type JobListQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first: Types.Scalars['Int']['input'];
  jobBenefitIds?: Types.InputMaybe<
    Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']
  >;
  jobCrewCategoryIds?: Types.InputMaybe<
    Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']
  >;
  prefCodes?: Types.InputMaybe<
    Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']
  >;
}>;

export type JobListQuery = {
  __typename?: 'Query';
  fastTimelineJobs: {
    __typename?: 'TimelineJobConnection';
    edges?: Array<{
      __typename?: 'TimelineJobEdge';
      node: {
        __typename?: 'TimelineJob';
        id: string;
        access: string;
        closestWorkTimeStartAtOfUpcomingOffers?: string | null;
        description: string;
        mainPhotoImageURL: string;
        numberOfUpcomingOffers: number;
        title: string;
        workplaceName: string;
        address: {
          __typename?: 'Address';
          id: string;
          address1: string;
          address2?: string | null;
          city: string;
          prefCode: string;
          zipCode: string;
        };
        category: {
          __typename?: 'JobCategory';
          id: string;
          labelJp: string;
          child?: { __typename?: 'JobCategory'; id: string; labelJp: string } | null;
        };
        jobBenefits?: Array<{ __typename?: 'JobBenefit'; id: string; labelJp: string }> | null;
        rangeOfHourlyWage?: {
          __typename?: 'IntRange';
          max?: number | null;
          min?: number | null;
        } | null;
        rangeOfWorkingTime?: {
          __typename?: 'IntRange';
          max?: number | null;
          min?: number | null;
        } | null;
      };
    } | null> | null;
    pageInfo: { __typename?: 'PageInfo'; endCursor?: string | null; hasNextPage: boolean };
  };
};

export type JobsRouteQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  jobBenefitIds?: Types.InputMaybe<
    Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']
  >;
  jobCrewCategoryIds?: Types.InputMaybe<
    Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']
  >;
  prefCodes?: Types.InputMaybe<
    Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']
  >;
}>;

export type JobsRouteQuery = {
  __typename?: 'Query';
  fastTimelineJobs: {
    __typename?: 'TimelineJobConnection';
    edges?: Array<{
      __typename?: 'TimelineJobEdge';
      node: {
        __typename?: 'TimelineJob';
        id: string;
        access: string;
        closestWorkTimeStartAtOfUpcomingOffers?: string | null;
        description: string;
        mainPhotoImageURL: string;
        numberOfUpcomingOffers: number;
        title: string;
        workplaceName: string;
        address: {
          __typename?: 'Address';
          id: string;
          address1: string;
          address2?: string | null;
          city: string;
          prefCode: string;
          zipCode: string;
        };
        category: {
          __typename?: 'JobCategory';
          id: string;
          labelJp: string;
          child?: { __typename?: 'JobCategory'; id: string; labelJp: string } | null;
        };
        jobBenefits?: Array<{ __typename?: 'JobBenefit'; id: string; labelJp: string }> | null;
        rangeOfHourlyWage?: {
          __typename?: 'IntRange';
          max?: number | null;
          min?: number | null;
        } | null;
        rangeOfWorkingTime?: {
          __typename?: 'IntRange';
          max?: number | null;
          min?: number | null;
        } | null;
      };
    } | null> | null;
    pageInfo: { __typename?: 'PageInfo'; endCursor?: string | null; hasNextPage: boolean };
  };
  jobBenefits: Array<{ __typename?: 'JobBenefit'; id: string; labelJp: string }>;
  jobCrewCategoryMasters: Array<{
    __typename?: 'JobCrewCategoryMaster';
    id: string;
    labelJp: string;
  }>;
};

export const JobBenefitOptionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobBenefitOption' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JobBenefit' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'labelJp' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobBenefitOptionFragment, unknown>;
export const JobCrewCategoryOptionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobCrewCategoryOption' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JobCrewCategoryMaster' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'labelJp' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobCrewCategoryOptionFragment, unknown>;
export const JobListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'JobList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobBenefitIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobCrewCategoryIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'prefCodes' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fastTimelineJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'prefCodes' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'prefCodes' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'jobCrewCategoryIds' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'jobCrewCategoryIds' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'jobBenefitIds' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'jobBenefitIds' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'JobListItem' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobListItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TimelineJob' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'access' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'prefCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'child' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'labelJp' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'labelJp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'closestWorkTimeStartAtOfUpcomingOffers' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobBenefits' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelJp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mainPhotoImageURL' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'preset' },
                      value: { kind: 'EnumValue', value: 'LARGE' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'useWebp' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfUpcomingOffers' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rangeOfHourlyWage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                { kind: 'Field', name: { kind: 'Name', value: 'min' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rangeOfWorkingTime' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                { kind: 'Field', name: { kind: 'Name', value: 'min' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workplaceName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobListQuery, JobListQueryVariables>;
export const JobsRouteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'JobsRoute' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobBenefitIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'jobCrewCategoryIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'prefCodes' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fastTimelineJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'prefCodes' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'prefCodes' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'jobCrewCategoryIds' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'jobCrewCategoryIds' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'jobBenefitIds' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'jobBenefitIds' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'JobListItem' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobBenefits' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'JobBenefitOption' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobCrewCategoryMasters' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'JobCrewCategoryOption' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobListItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TimelineJob' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'access' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'prefCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'child' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'labelJp' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'labelJp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'closestWorkTimeStartAtOfUpcomingOffers' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobBenefits' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelJp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mainPhotoImageURL' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'preset' },
                      value: { kind: 'EnumValue', value: 'LARGE' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'useWebp' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                },
              },
            ],
          },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfUpcomingOffers' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rangeOfHourlyWage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                { kind: 'Field', name: { kind: 'Name', value: 'min' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rangeOfWorkingTime' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                { kind: 'Field', name: { kind: 'Name', value: 'min' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workplaceName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobBenefitOption' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JobBenefit' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'labelJp' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JobCrewCategoryOption' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JobCrewCategoryMaster' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'labelJp' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobsRouteQuery, JobsRouteQueryVariables>;
